/* Shto SCP PDP "Pair it with": each card's ADD TO CART is the theme's own <product-form> (assets/product.js), which posts
   /cart/add, opens their cart drawer and fires cart:item-added once. This file only makes sure product.js is there and
   drops a second submit of the same card while its first add is on its way (one click = one add). Never touches the address. */
(function () {
  function ensureProductForm() {
    var holder = document.querySelector('[data-shto-pair-productjs]');
    if (customElements.get('product-form') || !holder || document.querySelector('script[data-shto-productjs]')) return;
    var s = document.createElement('script');
    s.src = holder.getAttribute('data-shto-pair-productjs');
    s.defer = true;
    s.setAttribute('data-shto-productjs', '');
    document.head.appendChild(s);
  }

  function initCard(card) {
    if (card.dataset.shtoPairOn) return;
    card.dataset.shtoPairOn = '1';
    var form = card.querySelector('product-form');
    var add = card.querySelector('[data-shto-pair-add]');
    if (!form || !add) return;
    var busy = false, timer = null;
    function done() {
      busy = false;
      clearTimeout(timer);
      add.classList.remove('is-busy');
      add.removeAttribute('aria-busy');
    }
    // Both listeners sit on the form; ours runs first (capture on <product-form>), so only stopImmediatePropagation
    // keeps the theme's handler from running a second time.
    form.addEventListener('submit', function (e) {
      if (busy || add.disabled) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      busy = true;
      add.classList.add('is-busy');
      add.setAttribute('aria-busy', 'true');
      timer = setTimeout(done, 8000);
    }, true);
    document.addEventListener('cart:item-added', done);
    document.addEventListener('product:variant-error', done);
  }

  function boot(root) {
    var cards = (root || document).querySelectorAll('[data-shto-pair-card]');
    if (!cards.length) return;
    try { ensureProductForm(); } catch (e) {}
    cards.forEach(initCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
